/** @format */

import {
  Grid,
  Typography,
  Button,
  Alert
} from "@mui/material";
import React, { useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import Swal from "sweetalert2";
import { getDailyReportAsExcel } from "../../api/tax/getDailyReportAsExcel";
import moment from "moment/moment";
import "moment/locale/tr"; // Türkçe dil desteğini ekliyoruz
import DateRangePicker from "../../components/DateRangePicker";
import { getNotificaitionReportAsExcel } from "../../api/tax/getNotificationReportAsExcel";

const NotificationReport = ({ setNotificationReportModalOpen }) => {
  const [startDate, setStartDate] = useState(moment().subtract(1, "month").startOf("month"));
  const [endDate, setEndDate] = useState(moment().subtract(1, "month").endOf("month"));
  const handleNotificationReportExcelDownload = async () => {

    try {
      await getNotificaitionReportAsExcel(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))
        .then((resp) => {
          Swal.fire({
            title: resp.data,
            icon: "success",
            confirmButtonText: "Tamam",
          });
          setNotificationReportModalOpen(false);
        })
        .catch((err) => {
          Swal.fire({
            title: err.response.data.message || "Hata oluştu",
            icon: "error",
            confirmButtonText: "Tamam",
          });
        });
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  return (
    <Grid
      container
      sx={{
        width: "30vw",
        display: "flex",
        flexDirection: "column",
        gap: 5
      }}
    >

      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        sx={{ color: "#003366" }}
      >
        BİLDİRİM RAPORU İNDİR
      </Typography>

      <Grid item sx={{ display: "flex", justifyContent: "center" }}>
        <Alert severity="info" sx={{ width: "100%" }}>
          Mükelleflerinize gönderdiğiniz belgelerin, alıcıya ulaşma ve okunma durumunu toplu görüntüleyebilmek için bu raporu kullanabilirsiniz.
        </Alert>
      </Grid>
      <Grid item sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          isLimitedRangeForMonth={false}
        />
      </Grid>
      <Grid item sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
          onClick={handleNotificationReportExcelDownload}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            paddingX: 4,
            paddingY: 1.5,
            fontSize: "1rem",
            width: "30%",
          }}
        >
          İndir
        </Button>
      </Grid>
    </Grid>
  );
};

export default NotificationReport;
